__turbopack_context__.v({
  "pill": "DiscountPill-module__H8a3OW__pill",
});
